import styled, { css } from 'styled-components'

export const Title = styled.div`
	padding: 8px 12px;
	border-top: 1px solid #ddd;
	border-bottom: 1px solid #ddd;
	background: ${(props) =>
		props.theme.colors.layout.treePanel.headerBackgroundColor};
	text-transform: uppercase;
	flex-grow: 0;
	flex-shrink: 0;
	display: flex;
	align-items: center;
`

export const CollapsedHeader = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
	padding-top: 8px;
`

export const TitleActions = styled.div`
	margin-left: auto;
	display: flex;
	align-items: center;
`

export const TitleAction = styled.div`
	cursor: pointer;
	padding: 3px;
	border-radius: 4px;
	width: 30px;
	text-align: center;
	margin-right: 5px;
	font-size: 1rem;

	&:hover {
		background-color: #265560;
		opacity: 0.5;
		color: white;
	}
`

export const ToggleButton = styled.div<{ $disabled?: boolean, $isChecked?: boolean; }>`
	cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
	padding: 3px;
	border-radius: 4px;
	width: 30px;
	text-align: center;
	margin-right: 5px;
	font-size: 1rem;
	opacity: ${(props) => (props.$disabled ? 0.4 : 1)};
	pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};

	&:hover {
		background-color: #265560;
		opacity: 0.5;
		color: white;
	}

	${(props) => css`
		color: ${props.$isChecked ? 'white' : 'initial'};
		background: ${props.$isChecked ? '#265560' : 'initial'};
		box-shadow: ${props.$isChecked ? '0px 0px 2px 0px #265560' : 'initial'};
	`}
`

